import { Box, Tab, useTheme } from "@mui/material";
import Tabs, { tabsClasses } from "@mui/material/Tabs";

import { AxisMapped, ReportDataDto } from "interfaces/report";
import "./style.css";
import { ThemeMode } from "enums/theme";

interface Props {
  sheetName: string;
  reportData: ReportDataDto<AxisMapped>;
  handleChangeSheetName: Function;
}

export default function ReportTabSheets({
  reportData,
  sheetName,
  handleChangeSheetName,
}: Props) {
  const theme = useTheme();

  const renderTabs = () => {
    return Object.keys(reportData).map((key, idx) => {
      return <Tab key={idx} value={key} label={key} />;
    });
  };

  return (
    <Tabs
      variant="scrollable"
      scrollButtons
      sx={{
        [`& .${tabsClasses.scrollButtons}`]: {
          "&.Mui-disabled": { opacity: 0.3 },
        },
        [`.Mui-selected`]: {
          fontWeight: 700,
          color: "#0b57d0",
          backgroundColor:
            theme.palette.mode === ThemeMode.LIGHT ? "#e1e9f7" : "#222529",
          borderColor:
            theme.palette.mode === ThemeMode.LIGHT ? "#e1e9f7" : "#222529",
        },
        [`.MuiTabs-indicator`]: {
          display: "none",
        },
        [`.MuiTabs-scroller`]: {
          order: -1,
          cursor: 'pointer'
        },
      }}
      className="tabs-container"
      value={sheetName}
      onChange={(_, value) => handleChangeSheetName(value)}
    >
      {renderTabs()}
    </Tabs>
  );
}
